import SimpleLineChart1 from "./SimpleLineChart1.vue";

export default SimpleLineChart1;
